<div class="container page-container">
  <div class="header-section">
    <h1 class="display-4">Upcoming Events</h1>
    <p class="subtitle">Join us for community gatherings, culturally enriching programs, and special exhibitions.</p>
  </div>

  <div class="events-list">
    <div class="event-card" *ngFor="let event of events">
      <div class="event-image-wrapper" [routerLink]="['/events', event.fields.url]">
        <div class="event-image" [style.background-image]="'url(' + event.fields.images?.[0]?.fields?.file?.url + ')'"></div>
        <div class="image-overlay">
          <span class="view-label">View Details</span>
        </div>
      </div>

      <div class="event-content">
        <div class="event-header">
          <h2 [innerHTML]="event.fields.title | mdToHtml"></h2>
          <span class="event-date">
            <ng-container *ngIf="event.fields.dateTime; else dateOnly">
              {{ event.fields.dateTime | date:'MMM d, y, h:mm a' }}
            </ng-container>
            <ng-template #dateOnly>
              {{ event.fields.date }}
            </ng-template>
          </span>
        </div>

        <div class="event-body">
          <p [innerHTML]="event.fields.shortDescription | mdToHtml"></p>
        </div>

        <div class="event-actions">
          <button mat-flat-button color="primary" [routerLink]="['/events', event.fields.url]">
            Learn More
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="no-events" *ngIf="events.length === 0">
    <div class="empty-state">
      <mat-icon>event_busy</mat-icon>
      <h2>No upcoming events at this time</h2>
      <p>Check back soon for updates!</p>
    </div>
  </div>


  <!-- Recent Past Events Section -->
  <div class="recent-past-section" *ngIf="pastEvents.length > 0">
    <div class="section-header">
      <h2>Recent Past Events</h2>
      <p class="section-subtitle">Did you miss out? Keep an eye using our event calendar.</p>
    </div>

    <div class="past-events-grid">
      <div class="past-event-card" *ngFor="let event of pastEvents">
        <div class="past-event-image" [routerLink]="['/events', event.fields.url]"
          [style.background-image]="'url(' + event.fields.images[0]?.fields?.file?.url + ')'">
          <div class="past-event-overlay">
            <span>View Details</span>
          </div>
        </div>
        <div class="past-event-content">
          <span class="past-event-date">
            <ng-container *ngIf="event.fields.dateTime; else pastDateOnly">
              {{ event.fields.dateTime | date:'MMM d, y, h:mm a' }}
            </ng-container>
            <ng-template #pastDateOnly>
              {{ event.fields.date }}
            </ng-template>
          </span>
          <h3 [innerHTML]="event.fields.title | mdToHtml"></h3>
        </div>
      </div>
    </div>

    <div class="view-all-container">
      <button mat-stroked-button color="primary" routerLink="/past-events">
        View Past Events Archive
        <mat-icon iconPositionEnd>history</mat-icon>
      </button>
    </div>
  </div>
</div>